import { Customer } from '@/models/customer';

export class State {
    public customers: Array<Customer> = [];
    public contactNames: Array<string> = [];
}
